import { render, staticRenderFns } from "./cmpconsultarclientes.vue?vue&type=template&id=5260a0c0&"
import script from "./cmpconsultarclientes.vue?vue&type=script&lang=js&"
export * from "./cmpconsultarclientes.vue?vue&type=script&lang=js&"
import style0 from "./cmpconsultarclientes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports